import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getApiClient, initializeApiClient } from "../../../../Services/apiService";


export const GetAllPR_TypeOfJobOpportunity = createAsyncThunk(
  "dropdowns/GetAllPR_TypeOfJobOpportunity",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDowns/GetAllPR_TypeOfJobOpportunity"
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const TypeOfJobOpportunityDropDown = createSlice({
  name: "TypeOfJobOpportunityDropDown",
  initialState: {
    TypeOfJobOpportunityDropDown: [],
    loadingTypeOfJobOpportunityDropDown: false,
    errorTypeOfJobOpportunityDropDown: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllPR_TypeOfJobOpportunity.pending, (state, action) => {
        state.loadingTypeOfJobOpportunityDropDown = true;
        state.TypeOfJobOpportunityDropDown = action.payload;
        state.errorTypeOfJobOpportunityDropDown = null;
      })
      .addCase(GetAllPR_TypeOfJobOpportunity.fulfilled, (state, action) => {
        state.loadingTypeOfJobOpportunityDropDown = false;
        state.TypeOfJobOpportunityDropDown = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllPR_TypeOfJobOpportunity.rejected, (state, action) => {
        state.loadingTypeOfJobOpportunityDropDown = false;
        state.errorTypeOfJobOpportunityDropDown = action.payload;
      });
  },
});

export default TypeOfJobOpportunityDropDown.reducer;
